import React, { useId } from "react";

import {
  Field,
  FieldDescription,
  FieldLabel,
} from "../../shadcn/components/ui/field";
import { Input } from "../../shadcn/components/ui/input";
import { Textarea } from "../../shadcn/components/ui/textarea";

// Labelled text input (or textarea with `multiline`) with optional helper text.
// With `aria-invalid`, the field and its helper text turn red.
const LabeledTextField = ({
  label,
  helperText,
  multiline = false,
  minRows,
  className,
  ...inputProps
}) => {
  const id = useId();
  const helpId = helperText ? `${id}-help` : undefined;
  const Control = multiline ? Textarea : Input;
  const invalid = Boolean(inputProps["aria-invalid"]) && inputProps["aria-invalid"] !== "false";
  return (
    <Field data-invalid={invalid || undefined} className={className}>
      <FieldLabel htmlFor={id}>
        {label}
        {inputProps.required ? <span aria-hidden="true"> *</span> : null}
      </FieldLabel>
      <Control
        id={id}
        rows={multiline ? minRows : undefined}
        aria-describedby={helpId}
        {...inputProps}
      />
      {helperText ? (
        <FieldDescription id={helpId} className={invalid ? "text-destructive" : undefined}>
          {helperText}
        </FieldDescription>
      ) : null}
    </Field>
  );
};

export default LabeledTextField;
